@if (shouldShowBanner) {
  <div class="banner banner--processing" role="alert" aria-live="polite">
    <span class="banner__icon" aria-hidden="true">!</span>

    <p class="banner__text">
      <strong class="banner__title">{{ title }}</strong>
      <span class="banner__description">{{ description }}</span>
    </p>

    <button
      type="button"
      class="banner__close"
      aria-label="Close banner"
      (click)="onCloseClick()"
    >
      <g99-icon-btn [icon]="closeIcon" [height]="12" [width]="12" />
    </button>
  </div>
}
